import { gql } from '@apollo/client'

export const revokeUserCourse = gql`
  mutation RevokeUserCourse($user: String!, $course: String!) {
    revokeUserCourse(user: $user, course: $course)
  }
`
